<template>
	<div class="page-wrapper">
		<transition appear name="fadeslow">
			<div class="menu-layer">
				<navigation :darken="true"></navigation>
			</div>
		</transition>

		<div class="empty-block"></div>

		<h1>Mood</h1>

		<div class="img-container">
			<div class="img-item" v-for="(item, index) in images" :key="index">
				<img class="preview-img-item" :src="`${item.src}`" @click="$photoswipe.open(index, images)">
			</div>
		</div>

	</div>
</template>

<script>

	import Navigation from "./Navigation.vue";

	export default {
		name: "Portfolio3",
		components: {
			Navigation
		},
		data () {
			return {
				welcomeText: 'TABI PHOTOGRAPHY',
				showModal: false,
				selectedImage: null,
				selectedImageIndex: 0,
				images: [{
                    src: require('../assets/portfolio3/CRW_1469_1080p.jpg'),
                    w: 720,
                    h: 1080
                }, {
                    src: require('../assets/portfolio3/CRW_1453-1080p.jpg'),
                    w: 720,
                    h: 1080
                }, {
                    src: require('../assets/portfolio3/CRW_0987-1080p.jpg'),
                    w: 720,
                    h: 1080
                }, {
                    src: require('../assets/portfolio3/_N2E0934-1080p.jpg'),
                    w: 720,
                    h: 1080
                }, {
                    src: require('../assets/portfolio3/_N2E0868-1080p.jpg'),
                    w: 720,
                    h: 1080
                }, {
                    src: require('../assets/portfolio3/_N2E0867-1080p.jpg'),
                    w: 720,
                    h: 1080
                }, {
                    src: require('../assets/portfolio3/_MG_4583-1080p.jpg'),
                    w: 720,
                    h: 1080
                }, {
                    src: require('../assets/portfolio3/_MG_4577-1080p.jpg'),
                    w: 720,
                    h: 1080
                }, {
                    src: require('../assets/portfolio3/_MG_4561-1080p.jpg'),
                    w: 720,
                    h: 1080
                }, {
                    src: require('../assets/portfolio3/_MG_4362-1080p.jpg'),
                    w: 720,
                    h: 1080
                }, {
                    src: require('../assets/portfolio3/_MG_4323-1080p.jpg'),
                    w: 720,
                    h: 1080
                }, {
                    src: require('../assets/portfolio3/_F5T3555-1080p.jpg'),
                    w: 720,
                    h: 1080
                }, {
                    src: require('../assets/portfolio3/_F5T3463-1080p.jpg'),
                    w: 720,
                    h: 1080
                }, {
                    src: require('../assets/portfolio3/_F5T3862-1080p.jpg'),
                    w: 720,
                    h: 1080
                }, {
                    src: require('../assets/portfolio3/_F5T3400-1080p.jpg'),
                    w: 720,
                    h: 1080
					 }
				]
			}
		}
	}

</script>

<style scoped>

	.page-wrapper {
		background-color: #282828;
	}

	.empty-block {
		padding-top: 4.5rem;
	}

	.menu-layer {
		position: fixed;
		top: 0;
		z-index: 10;
		width: 100%;
	}

	h1 {
		font-size: 1.2rem;
		text-align: center;
		color: #fff;
		margin: 1rem 0 0.5rem 1rem;
		font-weight: 100;
	}

	.img-container {
		display: flex;
		align-items: flex-start;
		flex-wrap: wrap;
		justify-content: center;
		align-items: center;
		height: 100%;
		margin: 0;
		padding: 0;
	}

	.img-item {
		transition: all 200ms ease;
		transform: scale(1.0);
	}

	.img-item:hover {
		transition: all 200ms ease;
		transform: scale(0.97);
	}

	.img-container img {
		margin: 0;
		padding: 8px;
		width: 42vw;
		height: 100%;
		transition: all 300ms ease-in-out;
	}

	/* required class name by photoswipe */
	.preview-img-item {
		margin: 0;
	}

	@media only screen and (min-width: 600px) {
		.img-container img {
			width: 30vw;
		}

		h1 {
			font-size: 2rem;
		}
	}

	@media only screen and (min-width: 900px) {
		.img-container img {
			width: 22vw;
		}

		h1 {
			font-size: 2rem;
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/Portfolio3.vue